import { useState } from 'react';
import { resolveImagePath } from '@/utils/imageMap';

interface NavigationItem {
  href: string;
  text: string;
}

interface HeaderProps {
  navigation?: NavigationItem[];
}

export function Header({ navigation = [] }: HeaderProps) {
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);

  const defaultNavigation: NavigationItem[] = [
    { href: '/', text: 'Home' },
    { href: '/about-me/', text: 'About Me' },
    { href: '/counseling-therapy/', text: 'Counseling & Therapy' },
    { href: '/kintsugi-gallery/', text: 'Kintsugi Gallery' },
    { href: '/faq-page/', text: 'FAQs' },
    { href: '/contact-us/', text: 'Contact Us' },
  ];

  const navItems = navigation.length > 0 ? navigation : defaultNavigation;
  const logoSrc = resolveImagePath('/images/logo.png');

  return (
    <header id="qodef-page-header" className="relative bg-white shadow-sm">
      {/* Desktop Header */}
      <div id="qodef-page-header-inner" className="hidden lg:block">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="flex items-center justify-between h-16">
            {/* Logo */}
            <div className="flex-shrink-0">
              <a href="/" className="flex items-center">
                <img
                  src={logoSrc}
                  alt="Concierge Couples Counseling"
                  className="h-8 w-auto"
                />
              </a>
            </div>

            {/* Desktop Navigation */}
            <nav className="hidden lg:flex lg:space-x-8">
              <ul id="menu-main-menu-1" className="flex space-x-8">
                {navItems.map((item, index) => (
                  <li key={index}>
                    <a
                      href={item.href}
                      className="text-gray-700 hover:text-gray-900 px-3 py-2 text-sm font-medium transition-colors duration-200"
                    >
                      <span>{item.text}</span>
                    </a>
                  </li>
                ))}
              </ul>
            </nav>
          </div>
        </div>
      </div>

      {/* Mobile Header */}
      <div id="qodef-page-mobile-header" className="lg:hidden">
        <div id="qodef-page-mobile-header-inner" className="px-4 sm:px-6">
          <div className="flex items-center justify-between h-16">
            {/* Mobile Logo */}
            <div className="flex-shrink-0">
              <a href="/" className="flex items-center">
                <img
                  src={logoSrc}
                  alt="Concierge Couples Counseling"
                  className="h-8 w-auto"
                />
              </a>
            </div>

            {/* Mobile Menu Button */}
            <div className="lg:hidden">
              <button
                onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
                type="button"
                className="bg-white inline-flex items-center justify-center p-2 rounded-md text-gray-400 hover:text-gray-500 hover:bg-gray-100 focus:outline-none focus:ring-2 focus:ring-inset focus:ring-indigo-500"
                aria-controls="mobile-menu"
                aria-expanded="false"
              >
                <span className="sr-only">Open main menu</span>
                {!isMobileMenuOpen ? (
                  // Menu icon
                  <svg className="block h-6 w-6" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor" aria-hidden="true">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M4 6h16M4 12h16M4 18h16" />
                  </svg>
                ) : (
                  // Close icon
                  <svg className="block h-6 w-6" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor" aria-hidden="true">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M6 18L18 6M6 6l12 12" />
                  </svg>
                )}
              </button>
            </div>
          </div>

          {/* Mobile Navigation Menu */}
          {isMobileMenuOpen && (
            <div className="lg:hidden" id="mobile-menu">
              <div className="px-2 pt-2 pb-3 space-y-1 sm:px-3 bg-white border-t border-gray-200">
                {navItems.map((item, index) => (
                  <a
                    key={index}
                    href={item.href}
                    className="text-gray-700 hover:text-gray-900 block px-3 py-2 text-base font-medium"
                  >
                    {item.text}
                  </a>
                ))}
              </div>
            </div>
          )}
        </div>
      </div>
    </header>
  );
}